/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uFileJson = A4uFileJson;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uFileJson(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    fillRule: "evenodd",
    points: "20 2 20 12 30 12 20 2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M19,14a.99974.99974,0,0,1-1-1V2H7A.9995.9995,0,0,0,6,3V33a.99974.99974,0,0,0,1,1H29a.99982.99982,0,0,0,1-1V14Zm-2.97661,3.76533a.45421.45421,0,0,1-.46325.44446l-1.03048.08455a.43069.43069,0,0,0-.45532.40088v3.08249a3.97022,3.97022,0,0,1-1.20178,2.213,4.12666,4.12666,0,0,1,1.20178,2.23145v3.08924a.43944.43944,0,0,0,.46338.40783h1.06354a.45414.45414,0,0,1,.46326.44446v1.52087a.45421.45421,0,0,1-.46326.44446H15.048c-2.04687,0-3.13888-1.72095-3.13888-3.68457v-2.316a1.939,1.939,0,0,0-.95682-1.79065.38074.38074,0,0,1,.00452-.68616,1.91344,1.91344,0,0,0,.9523-1.7987c0-.54346-.00842-.56568-.017-2.28089-.00988-1.97034,1.08493-3.66879,3.13889-3.66879l.52913-.08456a.45413.45413,0,0,1,.46325.44446Zm9.02434,6.57244a1.9595,1.9595,0,0,0-.97955,1.79065v2.316c0,1.96362-1.06928,3.68457-3.11615,3.68457h-.59719a.45421.45421,0,0,1-.46326-.44446V30.1637a.45414.45414,0,0,1,.46326-.44446h1.10744a.43944.43944,0,0,0,.46338-.40783V26.22217a4.12666,4.12666,0,0,1,1.20178-2.23145,3.97022,3.97022,0,0,1-1.20178-2.213V18.69522a.43069.43069,0,0,0-.45532-.40088H20.3871a.45422.45422,0,0,1-.46326-.44446v-1.5022a.45413.45413,0,0,1,.46326-.44445H20.969c2.054,0,3.126,1.69845,3.11616,3.66879-.00855,1.71521-.017,1.73743-.017,2.28089a1.93275,1.93275,0,0,0,.975,1.7987A.38074.38074,0,0,1,25.04773,24.33777Z"
  }));
}